import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Smartphone, Trophy, Activity, AlertCircle, TrendingUp } from 'lucide-react';
const steps = [{
  icon: Smartphone,
  title: 'Acompanhamento',
  description: 'O aluno acompanha sua própria evolução no app diariamente.'
}, {
  icon: Trophy,
  title: 'Engajamento',
  description: 'Participa de desafios e entra para o Hall da Fama.'
}, {
  icon: Activity,
  title: 'Hábito',
  description: 'Cria constância e disciplina naturalmente com o uso.'
}, {
  icon: AlertCircle,
  title: 'Proteção',
  description: 'Se ficar inativo, o sistema age automaticamente para recuperar.'
}, {
  icon: TrendingUp,
  title: 'Resultado',
  description: 'A academia reduz churn sem esforço operacional extra.'
}];
export function HowItWorks() {
  return <Section background="gray" id="how-it-works" data-id="element-110">
      <div className="text-center mb-16" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-4" data-id="element-112">
          Como funciona
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-113">
          Um ciclo virtuoso que beneficia tanto o aluno quanto a academia.
        </p>
      </div>

      <div className="relative" data-id="element-114">
        {/* Connecting Line (Desktop) */}
        <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0" data-id="element-115"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 relative z-10" data-id="element-116">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-full" data-id="element-117">
              <div className="w-14 h-14 bg-[#FF6B35] rounded-full flex items-center justify-center text-white font-bold text-xl mb-4 shadow-lg shadow-orange-200 relative" data-id="element-118">
                <step.icon className="h-6 w-6" data-id="element-119" />
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#2D3748] rounded-full flex items-center justify-center text-xs text-white border-2 border-white" data-id="element-120">
                  {index + 1}
                </div>
              </div>
              <h3 className="font-bold text-[#2D3748] mb-2" data-id="element-121">{step.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-122">{step.description}</p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}